import ko from './ko.json';
import en from './en.json';
import zh from './zh.json';
import de from './de.json';
import es from './es.json';
import pt from './pt.json';
import it from './it.json';
import pl from './pl.json';
import cs from './cs.json';
import uk from './uk.json';
import uz from './uz.json';
import hi from './hi.json';
import tr from './tr.json';
const translations = { ko, en, zh, de, es, pt, it, pl, cs, uk, uz, hi, tr };
export default translations;
